export enum DeliveryMethodEnum {
  NORMAL = 'NORMAL',
  CESAREAN_SCHEDULED = 'CESAREAN_SCHEDULED',
  CESAREAN_EMERGENCY = 'CESAREAN_EMERGENCY',
  HOME = 'HOME',
}

export const DELIVERY_METHOD_VALUES: DeliveryMethodEnum[] = [
  DeliveryMethodEnum.NORMAL,
  DeliveryMethodEnum.CESAREAN_SCHEDULED,
  DeliveryMethodEnum.CESAREAN_EMERGENCY,
  DeliveryMethodEnum.HOME,
];
